import { useEffect, useRef, useState } from "react";
import { Columns3, Users2, ChevronDown, Target, Clock, Shield, Handshake, Crosshair, Layers,
  AlertTriangle, Hand, Ban, ArrowUpCircle, ArrowDownCircle, Flag, Scale } from "lucide-react";
import { ARENA_COLS, ARENA_LABEL } from "./arenaData";

const STAT_FULL = {
  pts: "PTS (Πόντοι)", min: "MIN (Λεπτά)", reb: "REB (Ριμπάουντ)", ast: "AST (Ασίστ)",
  fg3m: "3PM (Τρίποντα)", pra: "PRA (Π+Ρ+Α)", tov: "TO (Λάθη)", stl: "STL (Κλεψίματα)",
  blk: "BLK (Τάπες)", oreb: "OREB (Επιθ. ριμπ.)", dreb: "DREB (Αμυν. ριμπ.)",
  pf: "PF (Φάουλ)", plus_minus: "+/-",
};
const STAT_ICON = {
  pts: Target, min: Clock, reb: Shield, ast: Handshake, fg3m: Crosshair, pra: Layers,
  tov: AlertTriangle, stl: Hand, blk: Ban, oreb: ArrowUpCircle, dreb: ArrowDownCircle, pf: Flag, plus_minus: Scale,
};
const SCOPE_ITEMS = [["overall", "Overall"], ["home", "Home"], ["away", "Away"]];

function StatDropdown({ metric, setMetric }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  useEffect(() => {
    if (!open) return;
    const onDown = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", onDown);
    return () => document.removeEventListener("mousedown", onDown);
  }, [open]);
  const Active = STAT_ICON[metric] || Target;
  return (
    <div className="pt-dd" ref={ref}>
      <button type="button" className="pt-dd-btn" aria-haspopup="listbox" aria-expanded={open}
        data-testid="arena-metric-select" onClick={() => setOpen((o) => !o)}>
        <Active size={15} className="pt-dd-ico" />
        <span className="pt-dd-text">{STAT_FULL[metric] || ARENA_LABEL[metric]}</span>
        <ChevronDown size={14} className="pt-dd-caret" />
      </button>
      {open && (
        <div className="pt-dd-menu" role="listbox" data-testid="arena-metric-menu">
          {ARENA_COLS.map((s) => {
            const Ico = STAT_ICON[s] || Target;
            return (
              <button key={s} type="button" role="option" aria-selected={metric === s}
                className={`pt-dd-item ${metric === s ? "is-active" : ""}`} data-testid={`arena-metric-opt-${s}`}
                onClick={() => { setMetric(s); setOpen(false); }}>
                <Ico size={15} /> <span>{STAT_FULL[s] || ARENA_LABEL[s]}</span>
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}

export function ArenaControls({ metric, setMetric, scope, setScope, layout, setLayout, menuOpen, setMenuOpen }) {
  return (
    <div className="pt-row2" data-testid="arena-controls">
      <div className="pt-field">
        <span className="pt-field-label">Ρόλος</span>
        <div className="pt-seg" role="group" aria-label="Ρόλος">
          <button type="button" className={layout === "team" ? "is-active" : ""} aria-pressed={layout === "team"}
            data-testid="arena-layout-team" onClick={() => setLayout("team")}><Users2 size={14} /> Ομάδα</button>
          <button type="button" className={layout === "role" ? "is-active" : ""} aria-pressed={layout === "role"}
            data-testid="arena-layout-role" onClick={() => setLayout("role")}>All</button>
        </div>
      </div>

      <div className="pt-field">
        <span className="pt-field-label">Στατιστικά</span>
        <StatDropdown metric={metric} setMetric={setMetric} />
      </div>

      <div className="pt-field">
        <span className="pt-field-label">Προβολή</span>
        <div className="pt-seg pt-scope" role="group" aria-label="Προβολή">
          <button type="button" className={`pt-espn ${scope === "espn" ? "is-active" : ""}`} aria-pressed={scope === "espn"}
            data-testid="arena-scope-espn" onClick={() => setScope("espn")}><span className="pt-espn-badge">ESPN</span></button>
          {SCOPE_ITEMS.map(([k, text]) => (
            <button key={k} type="button" className={scope === k ? "is-active" : ""} aria-pressed={scope === k}
              data-testid={`arena-scope-${k}`} onClick={() => setScope(k)}>{text}</button>
          ))}
        </div>
      </div>

      <button type="button" className={`pt-columns ${menuOpen ? "is-active" : ""}`} aria-expanded={menuOpen}
        aria-label="Columns" title="Columns" data-testid="arena-columns-button" onClick={() => setMenuOpen(!menuOpen)}>
        <Columns3 size={17} />
      </button>
    </div>
  );
}
